<kendo-upload
      [saveUrl]="uploadSaveUrl"
      [removeUrl]="uploadRemoveUrl"
      (upload)="uploadEventHandler($event)"
      [withCredentials]="false"
      [(ngModel)]="files"
      [disabled]="readonly"
    >
    <ng-template kendoUploadFileTemplate let-files let-state="state">
        <div>
            <a target="_blank" rel="noopener noreferrer" class="ant-upload-list-item-thumbnail ng-tns-c314274227-255 ng-star-inserted" href="http://hdbstech/AdgServices/ImageProcessing/ReadBlobImage?evalID=200565&amp;equipmentnumber=14167718&amp;type=B1_P1&amp;highquality=1"><img class="ant-upload-list-item-image ng-tns-c314274227-255 ng-star-inserted" src="http://hdbstech/AdgServices/ImageProcessing/ReadBlobImage?evalID=200565&amp;equipmentnumber=14167718&amp;type=B1_P1&amp;width=150" alt="200565_14167718_B1_P1.jpg"></a>
            Name: {{ files[0].name }} Size: {{ files[0].size }} bytes</div>
      </ng-template>
    </kendo-upload>